import { Box, Flex, Stack } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import generateFrontPath from "@raiden/library/libraries/utils/generateFrontPath";
import { useIntl } from "react-intl";
import { CenteredContent } from "../../components/CenteredContent";
import { ContactBand } from "../../components/ContactBand";
import { DataHandler } from "../../components/DataHandler";
import { PageLayout } from "../../components/PageLayout";
import { Splash } from "../../components/Splash";
import { Timeline } from "../../components/Timeline";
import { PostsContentView } from "../Posts/Common/ContentView";

/**
 * @typedef {Object} Props
 * @property {import("swr").SWRResponse<import("@raiden/library/types/Api/ApiResponse").ApiResponse<import("@raiden/library/types/Post").Post>>} swrResponsePost
 */

/**
 * @param {Props} props
 */
export function OurRole({ swrResponsePost }) {
  const intl = useIntl();

  const translate = useTranslate();

  const postData = swrResponsePost.data?.data;

  return (
    <PageLayout
      title={
        translate(postData?.current_revision?.title) ??
        intl.formatMessage({ defaultMessage: "Notre rôle" })
      }
      subtitle={
        translate(postData?.current_revision?.subtitle) ??
        intl.formatMessage({
          defaultMessage:
            "Les intervenants et délais estimés lors d’un sinistre",
        })
      }
      bottomAddon={<ContactBand />}>
      <Box px=".625rem">
        <CenteredContent>
          <Stack spacing="1.5rem">
            <DataHandler
              swrResponse={swrResponsePost}
              keepDataOnRevalidation={true}
              noResult={
                <Flex alignItems="center" flexDir="column" gap="1rem" mx="auto">
                  <Box width={{ base: "200px", lg: "700px" }}>
                    <Splash
                      src={generateFrontPath({
                        id: "@front.internal-assets",
                        parameters: { filePath: "illustrations/error.svg" },
                        includeBasePath: true,
                      })}
                      title={intl.formatMessage({
                        defaultMessage: "Erreur lors du chargement de la page",
                      })}
                    />
                  </Box>
                </Flex>
              }>
              {({ data: post }) => (
                <PostsContentView post={post ?? undefined} />
              )}
            </DataHandler>

            <Timeline />
          </Stack>
        </CenteredContent>
      </Box>
    </PageLayout>
  );
}
